var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Download",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-download","viewBox":"0 0 100 100"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <polygon points="65 65 65 70 95 70 95 95 5 95 5 70 35 70 35 65 0 65 0 100 100 100 100 65 65 65"/>
  <polygon points="67.68 43.79 52.5 58.97 52.5 0 47.5 0 47.5 58.96 32.32 43.79 28.79 47.32 50 68.53 71.21 47.32 67.68 43.79"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/download.svg